import { GetApiPayloadByUrl, GetApiResponseByUrl } from '@crossbeam/openapi';
import { Nullable } from '@crossbeam/types';

type ApiProposal = GetApiResponseByUrl<'/v0.1/proposal-codes/{code}/proposal'>;

export type Proposal = Omit<ApiProposal, 'sending_organization'> & {
  sending_organization: ApiProposal['sending_organization'] & { id: number };
  contact?: { name?: string | null; email?: string };
};
export type SharingLevel = 'use_defaults' | 'aggregates_only' | 'hidden';

export type AcceptProposalPayload = GetApiPayloadByUrl<
  '/v0.3/proposals/{id}/accept',
  'put'
>;

type SendingUser = { name: Nullable<string>; email: string };

export type SentPartnershipProposal = {
  id: number;
  status: string;
  created_at: string;
  updated_at?: Nullable<string>;
  contact_name: Nullable<string>;
  contact_email: Nullable<string>;
  contact_company: string;
  partner_candidate_id: Nullable<string>;
  sending_user: Nullable<SendingUser>;
  migrated_from_reveal: boolean;
  decline_reason?: Nullable<string>;
  decline_note?: Nullable<string>;
  declining_user?: Nullable<SendingUser>;
};

type ReceivedProposalsResponse =
  GetApiResponseByUrl<'/v0.1/proposals-received'>;
export type ReceivedPartnershipProposal = ReceivedProposalsResponse['items'][0];

type ProposalsResponse = GetApiResponseByUrl<'/v0.1/proposals'>;
export type OldSentPartnershipProposal = ProposalsResponse['items'][0];

export function isNewProposal(
  proposal: OldSentPartnershipProposal | SentPartnershipProposal,
): proposal is SentPartnershipProposal {
  return !('contact' in proposal);
}
